'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, Suspense, useReducer } from 'react';
import { useSearchParams } from 'next/navigation';
import PromotionDetails from '@/components/promotions/PromotionDetails';
import { useExplore } from './ExploreProvider';
import { MapPinModal } from './MapPinModal';
function modalReducer(state, action) {
  switch (action.type) {
    case 'URL_CHANGED':
      {
        const {
          id
        } = action.payload;
        if (!id) {
          // No id in URL - reset everything
          return {
            prevId: null,
            currentId: null,
            showModal: false,
            closedIds: new Set()
          };
        }
        if (id === state.currentId) {
          return state;
        }
        const wasIdAddedLater = state.prevId === null && id !== null;
        if (wasIdAddedLater || state.closedIds.has(id)) {
          return {
            prevId: id,
            currentId: id,
            showModal: false,
            closedIds: new Set([...state.closedIds, id])
          };
        }
        return {
          prevId: id,
          currentId: id,
          showModal: true,
          closedIds: state.closedIds
        };
      }
    case 'CLOSE_MODAL':
      {
        // User closed the modal - mark id as closed
        return {
          ...state,
          showModal: false,
          closedIds: state.currentId ? new Set([...state.closedIds, state.currentId]) : state.closedIds
        };
      }
    default:
      return state;
  }
}
function PromotionLinkContent() {
  const $ = _c(54);
  const searchParams = useSearchParams();
  const {
    markers,
    setViewMode,
    viewMode
  } = useExplore();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("promoid");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const id = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("view");
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const view = t1;
  const t2 = !!id;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = new Set();
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== id || $[6] !== t2) {
    t4 = {
      prevId: id,
      currentId: id,
      showModal: t2,
      closedIds: t3
    };
    $[5] = id;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const [state, dispatch] = useReducer(modalReducer, t4);
  let t5;
  let t6;
  if ($[8] !== id) {
    t5 = () => {
      dispatch({
        type: "URL_CHANGED",
        payload: {
          id
        }
      });
    };
    t6 = [id];
    $[8] = id;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[11] !== id || $[12] !== setViewMode || $[13] !== view) {
    t7 = () => {
      if (id && view && ["map", "list", "photos"].includes(view)) {
        setViewMode(view, {
          syncUrl: false
        });
      }
    };
    t8 = [id, view, setViewMode];
    $[11] = id;
    $[12] = setViewMode;
    $[13] = view;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  bb0: {
    if (!id || markers.length === 0) {
      t9 = null;
      break bb0;
    }
    let t10;
    if ($[16] !== id || $[17] !== markers) {
      let t11;
      if ($[19] !== id) {
        t11 = marker => {
          if (marker.type !== "promotion") {
            return false;
          }
          const markerId = marker.promotionId || marker.id?.replace(/^promotion-/, "").replace(/-loc-\d+$/, "");
          return markerId === id || marker.id === id || marker.id === `promotion-${id}`;
        };
        $[19] = id;
        $[20] = t11;
      } else {
        t11 = $[20];
      }
      t10 = markers.find(t11);
      $[16] = id;
      $[17] = markers;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    const promotion = t10;
    t9 = promotion || null;
  }
  const selectedPromotion = t9;
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      dispatch({
        type: "CLOSE_MODAL"
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("promoid");
      const newUrl = url.search ? `${url.pathname}${url.search}` : url.pathname;
      window.history.pushState({}, "", newUrl);
    };
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handleClose = t10;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      dispatch({
        type: "CLOSE_MODAL"
      });
      const url_0 = new URL(window.location.href);
      url_0.searchParams.delete("promoid");
      const newUrl_0 = url_0.search ? `${url_0.pathname}${url_0.search}` : url_0.pathname;
      window.history.pushState({}, "", newUrl_0);
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const handleExpiredClose = t11;
  if (!id || !state.showModal) {
    return null;
  }
  if (markers.length === 0) {
    return null;
  }
  if (!selectedPromotion) {
    let t12;
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = new Date(0);
      t13 = [];
      $[23] = t12;
      $[24] = t13;
    } else {
      t12 = $[23];
      t13 = $[24];
    }
    let t14;
    if ($[25] !== id) {
      t14 = <PromotionDetails isOpen={true} onClose={handleClose} onExpiredClose={handleExpiredClose} promotion={{
        id,
        title: "",
        offerText: "",
        offerDetails: "",
        vendor: "",
        vendorColor: "#000000",
        thumbnail: null,
        url: "",
        startDate: null,
        endDate: t12,
        locations: t13
      }} />;
      $[25] = id;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  const isExpired = selectedPromotion.endDate ? new Date(selectedPromotion.endDate) < new Date() : false;
  let t12;
  if ($[27] !== selectedPromotion.id || $[28] !== selectedPromotion.promotionId) {
    t12 = selectedPromotion.promotionId || selectedPromotion.id?.replace("promotion-", "");
    $[27] = selectedPromotion.id;
    $[28] = selectedPromotion.promotionId;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== selectedPromotion.locations) {
    t13 = selectedPromotion.locations || [];
    $[30] = selectedPromotion.locations;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== selectedPromotion.communityName || $[33] !== selectedPromotion.endDate || $[34] !== selectedPromotion.locationName || $[35] !== selectedPromotion.name || $[36] !== selectedPromotion.offerDetails || $[37] !== selectedPromotion.offerText || $[38] !== selectedPromotion.startDate || $[39] !== selectedPromotion.thumbnail || $[40] !== selectedPromotion.url || $[41] !== selectedPromotion.vendor || $[42] !== selectedPromotion.vendorColor || $[43] !== t12 || $[44] !== t13) {
    t14 = {
      id: t12,
      title: selectedPromotion.name,
      offerText: selectedPromotion.offerText,
      offerDetails: selectedPromotion.offerDetails,
      vendor: selectedPromotion.vendor,
      vendorColor: selectedPromotion.vendorColor,
      thumbnail: selectedPromotion.thumbnail,
      url: selectedPromotion.url,
      startDate: selectedPromotion.startDate,
      endDate: selectedPromotion.endDate,
      locations: t13,
      locationName: selectedPromotion.locationName,
      communityName: selectedPromotion.communityName
    };
    $[32] = selectedPromotion.communityName;
    $[33] = selectedPromotion.endDate;
    $[34] = selectedPromotion.locationName;
    $[35] = selectedPromotion.name;
    $[36] = selectedPromotion.offerDetails;
    $[37] = selectedPromotion.offerText;
    $[38] = selectedPromotion.startDate;
    $[39] = selectedPromotion.thumbnail;
    $[40] = selectedPromotion.url;
    $[41] = selectedPromotion.vendor;
    $[42] = selectedPromotion.vendorColor;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  const promotionData = t14;
  if (isExpired) {
    const t15 = promotionData.communityName || promotionData.locationName || "";
    let t16;
    if ($[46] !== promotionData || $[47] !== t15) {
      t16 = <PromotionDetails isOpen={true} onClose={handleClose} onExpiredClose={handleExpiredClose} communityName={t15} promotion={promotionData} />;
      $[46] = promotionData;
      $[47] = t15;
      $[48] = t16;
    } else {
      t16 = $[48];
    }
    return t16;
  }
  if (viewMode === "map") {
    let t15;
    if ($[49] !== selectedPromotion) {
      t15 = <MapPinModal item={selectedPromotion} isOpen={true} onClose={handleClose} />;
      $[49] = selectedPromotion;
      $[50] = t15;
    } else {
      t15 = $[50];
    }
    return t15;
  }
  const t15 = promotionData.communityName || promotionData.locationName || "";
  let t16;
  if ($[51] !== promotionData || $[52] !== t15) {
    t16 = <PromotionDetails isOpen={true} onClose={handleClose} onExpiredClose={undefined} communityName={t15} promotion={promotionData} />;
    $[51] = promotionData;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  return t16;
}
export default function PromotionLink() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><PromotionLinkContent /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}